module.exports = __webpack_public_path__ + "static/media/external-link-alt-solid.03979156.svg";